/**
 * Можливості відкритого API за контрактом (docs/api/openapi.json на момент збирання).
 * Модулі хвилі 2 вмикають свої елементи інтерфейсу лише коли потрібна операція є в контракті.
 */
const OPERATIONS = new Set<string>(typeof __ERS_API_OPERATIONS__ === 'undefined' ? [] : __ERS_API_OPERATIONS__);

/** apiHas('GET /api/v1/mgmt/me') */
export function apiHas(operation: string): boolean {
  return OPERATIONS.has(operation);
}
